import { Button } from "@dropbox/dig-components/buttons";
import { Spinner } from "@dropbox/dig-components/progress_indicators";
import { Text } from "@dropbox/dig-components/typography";
import { PictogramIcon } from "@dropbox/dig-icons";
import { UploadFolderLine } from "@dropbox/dig-icons/dist/mjs/assets";
import i18n from "@mirage/translations";
import classNames from "classnames";
import { useCallback, useRef, useState } from "react";
import styles from "./StackUploadPanel.module.css";

export const StackUploadPanel = ({
  upload,
  isUploading,
}: {
  upload: (file: File) => void;
  isUploading: boolean;
}) => {
  const logoInputRef = useRef<HTMLInputElement>(null);
  const [isLandingAreaHovered, setIsLandingAreaHovered] = useState(false);

  const handleFileDrop = useCallback(
    (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault();
      const file = event.dataTransfer.items[0].getAsFile();
      if (file) {
        upload(file);
      }
    },
    [upload],
  );

  const handleFileUpload = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      event.target.value = ""; // Clear the input value to allow re-uploading the same file
      if (file) {
        upload(file);
      }
    },
    [upload],
  );

  if (isUploading) {
    return (
      <div className={styles.uploadLandingArea}>
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <input
        type="file"
        accept="image/png, image/jpeg, image/gif, image/tiff"
        ref={logoInputRef}
        onChangeCapture={handleFileUpload}
        hidden
      />
      <div
        className={classNames(styles.uploadLandingArea, {
          [styles.uploadLandingAreaHovered]: isLandingAreaHovered,
        })}
        onDrop={handleFileDrop}
        onDragOver={(e) => {
          e.preventDefault();
          setIsLandingAreaHovered(true);
        }}
        onDragEnter={(e) => {
          e.preventDefault();
          setIsLandingAreaHovered(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setIsLandingAreaHovered(false);
        }}
      >
        <Text color="faint">
          <PictogramIcon
            src={UploadFolderLine}
            onClick={() => setTimeout(() => logoInputRef.current?.click(), 50)}
          />
        </Text>
        <Text>{i18n.t("stack_icon_upload_area")}</Text>
        <Button
          variant="opacity"
          withDropdownIcon
          onClick={() => {
            setTimeout(() => logoInputRef.current?.click(), 50);
          }}
        >
          {i18n.t("stack_icon_upload_button")}
        </Button>
      </div>
    </>
  );
};
